import { SxProps } from '@mui/material/styles';

export const facetNavigationAccordionSX: SxProps = {
	boxShadow: 'none',
	m: 0,
	px: 0,
	py: '10px !important',
};
